import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { navigationLinks } from '../../data/mockData';
import LanguageToggle from '../LanguageToggle';

const Header = () => {
    const { t } = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-transparent ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm border-gray-100 py-3' : 'bg-transparent py-5'
                }`}
        >
            <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
                {/* LOGO AREA */}
                <a href="/" className="flex items-center group">
                    <img
                        src="/lazmetalslogo.png"
                        alt="Laz Metals Logo"
                        className="h-20 md:h-24 w-auto object-contain group-hover:scale-105 transition-transform duration-300"
                    />
                </a>

                {/* DESKTOP NAVIGATION */}
                <nav className="hidden md:flex items-center gap-8">
                    {navigationLinks.map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            className="font-body text-sm font-medium text-gray-600 hover:text-primary transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full"
                        >
                            {t(link.label)}
                        </a>
                    ))}
                </nav>

                {/* CTA BUTTON & LANGUAGE */}
                <div className="hidden md:flex items-center gap-6">
                    <LanguageToggle />
                    <a href="https://api.whatsapp.com/send?phone=19292902022&text=Hola,%20estoy%20navegando%20su%20sitio%20web%20y%20deseo%20contactarme%20con%20un%20asesor%20comercial." target="_blank" rel="noopener noreferrer" className="btn-primary">
                        {t('nav.quote')}
                    </a>
                </div>

                {/* MOBILE MENU TOGGLE */}
                <button
                    className="md:hidden text-accent p-2"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* MOBILE NAVIGATION DROPDOWN */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg px-6 overflow-hidden flex flex-col gap-4 origin-top"
                    >
                        <div className="py-4 flex flex-col gap-4">
                            {navigationLinks.map((link) => (
                                <a
                                    key={link.label}
                                    href={link.href}
                                    className="font-body text-base font-medium text-gray-800 py-2 border-b border-gray-50 hover:text-primary"
                                >
                                    {t(link.label)}
                                </a>
                            ))}
                            <div className="flex justify-center py-2 border-t border-gray-100 mt-2">
                                <LanguageToggle />
                            </div>
                            <a href="https://api.whatsapp.com/send?phone=19292902022&text=Hola,%20estoy%20navegando%20su%20sitio%20web%20y%20deseo%20contactarme%20con%20un%20asesor%20comercial." target="_blank" rel="noopener noreferrer" className="btn-primary mt-2 text-center">
                                {t('nav.quote')}
                            </a>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
};

export default Header;
